import styles from "./NetworkInfo.module.sass";

interface NetworkInfoProps {
  icon?: string;
  title: string;
  description?: string;
  badge?: string;
}

const NetworkInfo = ({ icon, title, description, badge }: NetworkInfoProps) => {
  return (
    <div className={styles.network}>
      {icon && (
        <div className={styles.icon}>
          <img src={icon} alt={title} />
        </div>
      )}

      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        {description && <div className={styles.description}>{description}</div>}
      </div>

      {badge && <div className={styles.badge}>{badge}</div>}
    </div>
  );
};

export default NetworkInfo;
